import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Add, CreateOutlined } from "@mui/icons-material";
import { Chip, Stack, MenuItem, Menu, Tooltip } from "@mui/material";
import { getAllTestSuites } from "../../redux-store/testSuiteReducers/testSuiteActions";
import AttachTestSuiteModal from "./AttachTestSuiteModal";
import CreateTestSuiteModal from "./CreateTestSuiteModal";

const TestSuiteAttach = ({ projectId }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const selectedTestScenarios = useSelector((state) => state.testScenario.selectedTestScenarios);
  const isDisabled = !selectedTestScenarios?.length;

  const styles = {
    chip: {
      border: "1px solid var(--primary-color)",
      padding: "14px 0",
      borderRadius: "4px",
      fontWeight: 500,
      opacity: isDisabled ? 0.6 : 1,
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      color: 'var(--text-primary)',
      backgroundColor: 'var(--background-primary)',
      '& .MuiChip-icon': {
        color: 'var(--primary-color)',
      },
      '&.MuiChip-disabled': {
        opacity: 0.6,
        border: "1px solid var(--primary-color-light)",
        color: 'var(--text-secondary)',
        '& .MuiChip-icon': {
          color: 'var(--text-secondary)',
        }
      }
    },
    menu: {
      mt: 0.5,
      '& .MuiPaper-root': {
        backgroundColor: 'var(--background-primary)',
        color: 'var(--text-primary)',
        border: '1px solid var(--borderColor)',
      }
    },
    menuItem: {
      color: 'var(--text-primary)',
      '&:hover': {
        backgroundColor: 'var(--hover-bg)',
      },
      '& .MuiSvgIcon-root': {
        color: 'var(--primary-color)',
        marginRight: '8px',
      }
    }
  };

  useEffect(() => {
    fetchAllTestSuites();
  }, []);

  const fetchAllTestSuites = async () => {
    await dispatch(
      getAllTestSuites({
        projectId: projectId,
        pageSize: 100000,
        pageNumber: 1,
      })
    );
  };

  const handleClick = (event) => {
    if (isDisabled) return;
    setAnchorEl(
      event.currentTarget.tagName === "svg"
        ? event.currentTarget.parentNode
        : event.currentTarget
    );
  };

  const onCreate = () => {
    setAnchorEl("");
    setShowCreateModal(true);
  };

  const onAdd = () => {
    setAnchorEl("");
    setShowAddModal(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setShowAddModal(false);
    setShowCreateModal(false);
  };

  return (
    <>
      <Tooltip 
        title="To Create/Add to Test Suite, select the active test scenarios"
        placement="top"
        arrow
      >
        <span>  
          <Chip
            id="attach-test-suite"
            label="Create/Add to Test Suite"
            icon={<Add />}
            onClick={handleClick}
            size="small"
            disabled={isDisabled}
            sx={styles.chip}
          />
        </span>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        onClose={handleClose}
        sx={styles.menu}
        open={Boolean(anchorEl)}
        className="attach-test-suite-menu"
      >
        <Stack spacing={1}>
          <MenuItem onClick={onCreate} sx={styles.menuItem}>
            <CreateOutlined />
            Create new test suite
          </MenuItem>
          <MenuItem onClick={onAdd} sx={styles.menuItem}>
            <Add />
            Add to existing test suite
          </MenuItem>
        </Stack>
      </Menu>
      {showAddModal && (
        <AttachTestSuiteModal
          projectId={projectId}
          open={showAddModal}
          onClose={handleClose}
          onCancel={handleClose}
        />
      )}
      {showCreateModal && (
        <CreateTestSuiteModal
          projectId={projectId}
          open={showCreateModal}
          onClose={handleClose}
          onCancel={handleClose}
        />
      )}
    </>
  );
};

export default TestSuiteAttach;